module.exports = __webpack_public_path__ + "static/media/Group 757.7a4be570.svg";